export const preparePrinter = () => {
    let port = window.port;
    if (!port) {
        console.log("No port found");
        return;
    }
    port?.postMessage("setMode:2");
    port?.postMessage("setCopy:1");
    port?.postMessage("setGap:0");
    port?.postMessage("setWidth:70");
    port?.postMessage("setHeight:50");
    port?.postMessage("setPosX:0");
    port?.postMessage("setPosY:100");
    port?.postMessage("setTopLineFeed:0");
    port?.postMessage("setImageWidth:640");
};

export const connectToPrinter = (address) => {
    let port = window.port;
    if (!port) {
        console.log("No port found");
        return;
    }
    port?.postMessage("setDeviceId:" + address);
};
